import { useEffect } from "react";

type PageMetaProps = {
  title?: string;
  description?: string;
  ogTitle?: string;
  ogDescription?: string;
  ogUrl?: string;
  ogImage?: string;
  twitterTitle?: string;
  twitterDescription?: string;
  twitterImage?: string;
  canonicalUrl?: string;
};

export function usePageMeta({
  title,
  description,
  ogTitle,
  ogDescription,
  ogUrl,
  ogImage,
  twitterTitle,
  twitterDescription,
  twitterImage,
  canonicalUrl,
}: PageMetaProps) {
  useEffect(() => {
    if (title) document.title = title;

    const setMetaTag = (attr: string, key: string, value: string) => {
      if (!value) return;
      let element = document.querySelector(`meta[${attr}="${key}"]`);
      if (!element) {
        element = document.createElement("meta");
        element.setAttribute(attr, key);
        document.head.appendChild(element);
      }
      element.setAttribute("content", value);
    };
    const setCanonical = (url: string) => {
      if (!url) return;
      let link: HTMLLinkElement | null = document.querySelector(
        "link[rel='canonical']"
      );
      if (!link) {
        link = document.createElement("link");
        link.setAttribute("rel", "canonical");
        document.head.appendChild(link);
      }
      link.setAttribute("href", url);
    };

    setMetaTag("name", "description", description ?? "");
    setMetaTag("property", "og:title", ogTitle || title || "");
    setMetaTag(
      "property",
      "og:description",
      ogDescription || description || ""
    );
    setMetaTag("property", "og:url", ogUrl ?? "");
    setMetaTag("property", "og:image", ogImage ?? "");
    setCanonical(canonicalUrl || ogUrl || window.location.href);

    setMetaTag("name", "twitter:card", "summary_large_image"); 
    setMetaTag("name", "twitter:title", twitterTitle || ogTitle || title || "");
    setMetaTag("name", "twitter:description", twitterDescription || ogDescription || description || "");
    setMetaTag("name", "twitter:image", twitterImage || ogImage || "");
  }, [title, description, ogTitle, ogDescription, ogUrl, ogImage, twitterTitle, twitterDescription, twitterImage, canonicalUrl]);
}
